import { ReactNode } from 'react';
import { toast, Flip } from 'react-toastify';

import { getStateOutsideOfComponent } from 'reduxState/store';

import { warningOrErrorMessage } from './notificationsRender';
import { NotificationObject } from './notificationTypes';

export const DISPLAYED_TIME_MS = 5_000;

function snowToast(
  message: ReactNode,
  toastId: string,
  type?: 'error' | 'success' | 'warning',
  autoCloseDisabled = false
) {
  toast(message, {
    position: 'bottom-right',
    theme: 'colored',
    type,
    transition: Flip,
    autoClose: autoCloseDisabled ? false : DISPLAYED_TIME_MS,
    toastId,
    // We are using onVisibilityChange which makes things a bit buggy when this is on
    pauseOnFocusLoss: false,
    // onClose: () => alert('CLOSED'),
  });
}

/** Display notification. If user has window minimized, notification once he reopen app */
export async function displayBasicNotification(
  message: ReactNode,
  /** Prevent same toast to be displayed twice */
  uniqueId: string,
  type?: 'error' | 'success' | 'warning',
  autoCloseDisabled?: boolean
) {
  const appState = await getStateOutsideOfComponent();
  if (appState.exchange.userGuide.notificationsDisabled) {
    console.log(
      '[displayBasicNotification] Notification canceled - disabled in settings'
    );
    return;
  }

  const isPageHidden = document.hidden;

  if (!isPageHidden) {
    snowToast(message, uniqueId, type, autoCloseDisabled);
    return;
  }

  const onVisibilityChange = () => {
    if (!document.hidden) {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      snowToast(message, uniqueId, type, autoCloseDisabled);
    }
  };

  document.addEventListener('visibilitychange', onVisibilityChange);
}

/** Display error toast which needs to be manually closed */
// export function displayPersistentErrorNotification(message: string) {
//   displayBasicNotification(
//     warningOrErrorMessage(message),
//     message, // ID will be full message
//     'error',
//     true
//   );
// }

export function displayWarningNotification(message: string) {
  displayBasicNotification(
    warningOrErrorMessage(message),
    message, // ID will be full message
    'warning'
  );
}

export function closeDisplayedNotification(type: NotificationObject['type']) {
  toast.dismiss(type);
}

(window as any).globalRenderTestWarning = () =>
  displayWarningNotification('Test notification warning');
